import { NavLink, useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import LogoutIcon from '@mui/icons-material/Logout';
import { Avatar, Box, Button, Checkbox, Chip, CircularProgress, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from "@mui/material";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DoneIcon from '@mui/icons-material/Done';
import RemoveDoneIcon from '@mui/icons-material/RemoveDone';
import DeleteIcon from '@mui/icons-material/Delete';
import { useEffect, useRef, useState } from "react";
import { collection, deleteDoc, deleteField, doc, FieldValue, getDoc, getDocs, onSnapshot, query, setDoc, updateDoc, where } from "firebase/firestore";
import { db } from "..";
import { Container } from "@mui/system";
import FilterListIcon from '@mui/icons-material/FilterList';
import AddIcon from '@mui/icons-material/Add';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import FindHatm from "../components/FindHatm";
import LoadingScreen from "../components/LoadingScreen";
import ReadList from "../components/ReadList";
import { cleanUserHatms } from "../utils/helpers";


export default function HomePage() {

    const [state, setState] = useState({})
    const [loading, setLoading] = useState(true)
    const [hatms, setHatms] = useState([])
    const [readAnchorEl, setReadAnchorEl] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [userData, setUserData] = useState({});


    // asc des(azalan)'dayken yukarıda en yeni eleman gözükecek
    // asc(yükselen)'deyken yukarıda en eski eleman gözükecek
    const [readOrder, setReadOrder] = useState("des")
    const [order, setOrder] = useState("des")

    // false ise kendi ve diğer insanlarınkini gösterir
    // true iken sadece kullanıcının hatimleri gözükür
    const [isMine, setIsMine] = useState(false)

    const [chosenHatms, setChosenHatms] = useState([]);

    const open = Boolean(anchorEl);
    const readListOpen = Boolean(readAnchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleReadListClick = (event) => {
        setReadAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleReadListClose = () => {
        setReadAnchorEl(null);
    };


    const navigate = useNavigate()
    let auth = getAuth()

    function handleCheck(checked, hatmId) {

        var newChosenHatms = [...chosenHatms]

        if (checked) {
            newChosenHatms.push(hatmId)
        } else {
            newChosenHatms = newChosenHatms
                .filter(hatm => {
                    if (hatm !== hatmId) {
                        return hatm
                    }
                })
        }

        setChosenHatms([...newChosenHatms])

    }

    function deleteHatms() {

        chosenHatms.map(hatmId => {

            console.log(userData.hatms)

            updateDoc(doc(db, 'users', auth.currentUser.uid), {
                [`hatms.${hatmId}`]: deleteField()
            }, { merge: true })

            Object.values(userData.hatms).filter(hatm => {
                if (hatm !== hatmId) {
                    return hatm
                }
            })
        })

        setChosenHatms([])
    }

    function Hatms() {

        // isMine
        // order

        var processedHatms = hatms

        if (isMine) {
            processedHatms = processedHatms.filter(hatm => hatm.creator === auth.currentUser.uid)
        }

        processedHatms = processedHatms.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(order === "asc" ? a.date : b.date) - new Date(order === "asc" ? b.date : a.date);
        });

        return <List
            sx={{ width: '100%', bgcolor: 'background.paper' }}
            aria-label="contacts">
            {
                processedHatms.map((hatm, i) => {
                    return <Box key={i} sx={{
                        border: "solid 1px",
                        padding: "5px 15px",
                        borderRadius: processedHatms.length < 2 ? "10px" : i === 0 ? "10px 10px 0  0" : i === processedHatms.length - 1 ? "0 0 10px 10px" : "0",
                        display: "flex", justifyContent: "left"
                    }}>
                        <Checkbox checked={chosenHatms.includes(hatm.id)} onChange={(event, checked) => handleCheck(checked, hatm.id)}></Checkbox>
                        <NavLink to={"/hatimler/" + hatm.id} style={{ all: "unset" }}><p>{hatm.title}</p></NavLink>

                    </Box>
                })
            }
        </List>
    }

    function getHatms(user) {
        if (!user || !user.hatms) return;
        
        // Temizlenmiş hatms verisini kullan
        const cleanedHatms = cleanUserHatms(user.hatms, auth.currentUser.uid);
        user.hatms = cleanedHatms;
        
        let ids = Object.keys(cleanedHatms);
        let batch = []

        let done = false

        let hatmsData = []
        

        for (let i = 0; !done; i++) {

            batch = ids.slice(i * 10, i !== 0 ? (i+1) * 10 : 10)

            if(batch < 11) {
                done = true
            }

            if (ids.length > 0 && batch.length > 0) {
                
                const q = query(collection(db, 'hatms'), where("id", "in", batch))

                getDocs(q).then(response => {
                    response.docs.map(doc => {
                        hatmsData.push(doc.data())
                    })

                    setHatms(hatmsData)
                    setUserData({ ...user })
                    setLoading(false)

                }, [])

            } else {
                setHatms([])
                setUserData({ ...user, hatms: [] })
                setLoading(false)
            }

        }
    }

    function getDb() {
        // Kullanıcı hatim id'lerini çekiyor
        getDoc(doc(db, "users", auth.currentUser.uid)).then((doc) => {
            getHatms(doc.data())
        })
    }

    useEffect(() => {

        onAuthStateChanged(auth, (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/firebase.User

                console.log("test")

                onSnapshot(doc(db, "users", auth.currentUser.uid), (doc) => {
                    getHatms(doc.data())
                });

            } else {
                // User is signed out
                window.location.href = '/tanitim';
            }
        }, []);

    }, [])



    if (loading) {
        return <LoadingScreen />
    }

    return <Container sx={{ paddingTop: "20px" }}>

        <div style={{ display: "flex", justifyContent: "center" }}><Avatar></Avatar></div>
        <h3 style={{ textAlign: "center" }}>{auth.currentUser?.displayName}</h3>

        <br />

        <ReadList {...{ isRestricted: true }} />

        {/* /////////////////////////////////////////////////////////////////////////////////////////////////////// */}

        <div style={{ display: "flex", justifyContent: "space-between" }}>
            {
                chosenHatms.length < 1 ? <><h3>Hatimler</h3>
                    <div>

                        <IconButton onClick={() => { navigate('hatimolustur') }}>
                            <AddIcon />
                        </IconButton>

                        <IconButton onClick={handleClick}
                            size="small"
                            sx={{ ml: 2 }}
                            aria-controls={open ? 'account-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}>
                            <FilterListIcon />
                        </IconButton>

                    </div></> : <>

                    <h3>{chosenHatms.length} Seçildi</h3>

                    <IconButton onClick={() => { deleteHatms() }}>
                        <DeleteIcon />
                    </IconButton>

                </>
            }

            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={() => {
                    setOrder(order === 'asc' ? 'des' : 'asc')
                }}>
                    <ListItemIcon>
                        {order === 'asc' ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
                    </ListItemIcon>
                    {order === 'asc' ? "Eskiden Yeniye" : "Yeniden Eskiye"}
                </MenuItem>

                <MenuItem onClick={() => { setIsMine(!isMine) }}>
                    <ListItemIcon>
                        <Checkbox sx={{ padding: "0" }} checked={isMine} />
                    </ListItemIcon>
                    Oluşturduklarım
                </MenuItem>
            </Menu>
        </div>

        {
            hatms.length < 1 ? <Box sx={{ padding: "20px", backgroundColor: "#F9F9F9", margin: "15px 0", display: "flex", justifyContent: "center", borderRadius: "10px" }}>
                <p>Katıldığın bir hatim bulunmuyor.</p>
            </Box>
                :
                <Hatms />
        }

        <FindHatm />


        {/* <Box sx={{ margin: "30px 0px" }}><ContactForm /></Box> */}

    </Container>



}